import {
  SearchOrdersResponse,
  CursorSearch,
} from './src/ecom-v1-order-orders.universal';

export * from './src/ecom-v1-order-orders.universal.js';

/** @hidden */
export type OrderSearch = {};

/**
 * Retrieves a list of orders, given the provided paging, filtering, and sorting.
 *
 *
 * Search Orders runs with these defaults, which you can override:
 *
 * - `createdDate` is sorted in `DESC` order.
 * - `cursorPaging.limit` is `100`.
 *
 * > **Note:** Search Orders does not return orders with `status: "INITIALIZED"`, regardless of the filter applied. To retrieve an order with `status: "INITIALIZED"`, use [Get Order](https://dev.wix.com/docs/api-reference/business-solutions/e-commerce/orders/orders/get-order).
 *
 * To learn how to query or search orders, see [API Query Language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language).
 * @param search - Search options.
 * @public
 * @requiredField search
 * @permissionId ECOM.READ_ORDERS
 * @applicableIdentity APP
 * @fqn com.wix.ecom.orders.v1.Orders.SearchOrders
 */
export declare function searchOrders(
  search: CursorSearch
): Promise<SearchOrdersResponse>;
